import invariant from 'invariant';

import { configString } from 'utils/config';
import { isNotEmpty } from 'utils/functional';

const getVolopsSearchIndex = (
  actionDateFacet?: Record<string, number> | null | undefined,
  sort?: string | null | undefined
) => {
  const volopsIndexName = configString('algolia', 'volopsIndexName');
  invariant(isNotEmpty(volopsIndexName), 'volopsIndexName cannot be empty');
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-nested-ternary
  return actionDateFacet && (actionDateFacet.endsGT || actionDateFacet.startsLT)
    ? `${volopsIndexName}-starts-asc`
    : sort === 'relevance'
    ? volopsIndexName
    : `${volopsIndexName}-published-desc`;
};

// eslint-disable-next-line import/no-default-export
export default getVolopsSearchIndex;
